import { Tooltip, TooltipProps } from '@mui/material';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import clsx from 'clsx';
import type { IconType } from 'react-icons/lib';
import { MdClose } from 'react-icons/md';
import Fade from '@mui/material/Fade';

type ButtonWithIconProps = IconButtonProps & {
  Icon?: IconType;
  iconClassName?: string;
  tooltip?: NonNullable<React.ReactNode>;
  tooltipProps?: Omit<TooltipProps, 'children'>;
};

const textSizeClasses = ['text-xs', 'text-sm', 'text-base', 'text-lg', ...['', '2', '3', '4', '5', '6', '7', '8', '9'].map((size) => `text-${size}xl`)];

const ButtonWithIcon: React.FC<ButtonWithIconProps> = ({ onClick, size = 'small', Icon = MdClose, iconClassName = '', className = '', tooltip = 'Close', tooltipProps, ...props }) => {
  const classNames: string[] = className.split(' ').map((cName) => cName.trim());
  const hasTextSize = Boolean(classNames.find((c) => textSizeClasses.includes(c))?.length ?? false);

  const renderIconButton = () => (
    <IconButton
      size={size}
      className={clsx(!hasTextSize && 'text-xl', ...className.split(' '), 'mx-1', 'text-pc-1')}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick?.(e);
      }}
      sx={{ margin: '-.5rem' }}
      aria-label={!props['aria-label'] && tooltip}
      {...props}
    >
      <Icon className={iconClassName} />
    </IconButton>
  );

  if (props.disabled) {
    return renderIconButton();
  }

  return (
    <Tooltip
      title={tooltip}
      TransitionComponent={Fade}
      TransitionProps={{
        timeout: 0,
      }}
      {...tooltipProps}
    >
      {renderIconButton()}
    </Tooltip>
  );
};

export default ButtonWithIcon;
